import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
} from '@angular/router';
import { Store } from '@ngrx/store';

import { State } from '../reducers/root.reducer';
import {
  SearchResultsReset,
} from '../actions/search.actions';
import { ResetResourceFacetsAction } from 'search/actions/facet.actions';

@Injectable()
export class SearchResolver implements Resolve<any> {

  constructor(
    private store: Store<State>,
  ) {}

  public resolve(route: ActivatedRouteSnapshot) {
    const queryParams: any = route.queryParams;

    if (!queryParams.metadata && !queryParams.query && !queryParams.boolQuery) {
      this.resetAll();
      return;
    }
  }

  private resetAll() {
    this.store.dispatch(new SearchResultsReset());
    this.store.dispatch(new ResetResourceFacetsAction());
  }
}
